import React from 'react';
import { ArrowRight, Check, Shield } from 'lucide-react';
import FadeIn from './FadeIn';

const TrialHero = () => {
  return (
    <section className="py-20 bg-gradient-to-b from-[color:var(--primary-50)] to-white">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
        <FadeIn>
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-[color:var(--text-primary)] mb-6 leading-tight">
              Vyzkoušejte si Školobot zdarma<br className="hidden md:block" /> přímo ve své škole
            </h2>
            <p className="text-base md:text-lg text-[color:var(--text-secondary)] max-w-3xl mx-auto leading-relaxed">
              Poznejte v praxi AI nástroj, který je vyvinutý na míru českému školství. Školobot rozumí české školní realitě, pedagogické terminologii i tomu, co pedagogové a vedení školy skutečně řeší. V trial verzi si ho vyzkoušíte přímo na svých školních datech a ve své každodenní praxi — ne na umělých ukázkách nebo obecných příkladech.
            </p>
          </div>
        </FadeIn>

        <FadeIn delay={0.1}>
          <div className="max-w-4xl mx-auto">
            {/* Main content row */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-start">
              {/* Left — benefits */}
              <div>
                <h3 className="text-2xl font-bold text-[color:var(--text-primary)] mb-6">
                  Plná funkcionalita, bez závazku.
                </h3>
                <div className="space-y-4">
                  {[
                    'Vyzkoušíte si Školobot na vlastních školních datech',
                    'Plný přístup ke všem funkcím po dobu trialu',
                    'Více zkušebních licencí pro více pedagogů najednou',
                    'Bez platební karty, bez automatického prodloužení',
                  ].map((item, i) => (
                    <div key={i} className="flex items-start gap-3">
                      <div className="w-5 h-5 rounded-full bg-[color:var(--primary-500)] flex items-center justify-center flex-shrink-0 mt-0.5">
                        <Check className="w-3 h-3 text-white" />
                      </div>
                      <span className="text-sm text-[color:var(--text-primary)]">{item}</span>
                    </div>
                  ))}
                </div>
                <p className="text-xs text-[color:var(--text-muted)] mt-4">
                  Zkušební verze zahrnuje balíček kreditů, které lze využít bez omezení. Po vyčerpání se kredity automaticky nedoplňují.
                </p>
              </div>

              {/* Right — CTA + MŠMT */}
              <div className="flex flex-col gap-5">
                <a href="https://app.skolobot.cz/register" target="_blank" rel="noopener noreferrer">
                  <button className="w-full bg-[color:var(--primary-500)] hover:bg-[color:var(--primary-600)] text-white px-8 py-5 rounded-2xl font-semibold shadow-lg hover:shadow-xl transition-all flex items-center justify-center gap-3 text-lg">
                    Vyzkoušet zdarma
                    <ArrowRight className="w-5 h-5" />
                  </button>
                </a>

                <a href="/#webinar">
                  <button className="w-full bg-white border-2 border-[color:var(--primary-500)] text-[color:var(--primary-600)] px-8 py-4 rounded-2xl font-semibold hover:bg-[color:var(--primary-50)] transition-all flex items-center justify-center gap-3">
                    Webinář zdarma
                  </button>
                </a>

                <div className="bg-[color:var(--primary-50)] rounded-xl p-4 flex items-start gap-3">
                  <Shield className="w-5 h-5 text-[color:var(--primary-600)] flex-shrink-0 mt-0.5" />
                  <p className="text-xs text-[color:var(--text-secondary)] leading-relaxed">
                    <strong className="text-[color:var(--text-primary)]">Lze hradit jako učební pomůcku.</strong> Školobot je koncipovaný v souladu s metodickým výkladem MŠMT „Digitální technologie jako učební pomůcka" — pořízení lze za splnění podmínek metodiky hradit z veřejných prostředků podle § 160 školského zákona.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>
  );
};

export default TrialHero;
